import createLucideIcon from '../createLucideIcon';

const Redo = createLucideIcon('RedoIcon', [
  ['path', { d: 'M21 7v6h-6', key: '3ptur4' }],
  ['path', { d: 'M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7', key: '1kgawr' }],
]);

export default Redo;
